import { render, staticRenderFns } from "./ContentHeaderType.vue?vue&type=template&id=2e7215d2&"
import script from "./ContentHeaderType.vue?vue&type=script&lang=js&"
export * from "./ContentHeaderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports